import React from "react";
import { jiraTicketKey, jiraTicketUrl } from "ee-utils";
import { process } from "../../Process";
/**
 * A ticket rendered as a link to Jira.
 *
 * The URL is rebuilt from the key rather than stored (see `jiraTicketUrl`), and
 * a value that is not an issue key renders as plain text: incidents written
 * before tickets were normalized hold whatever was typed at the time, and a
 * link to a Jira page that does not exist is worse than no link.
 */
export var TicketLink = function (_a) {
    var ticket = _a.ticket, _b = _a.emptyText, emptyText = _b === void 0 ? "None" : _b, className = _a.className;
    // Normalized for display as well as on write: incidents recorded before the
    // service started storing keys may hold a pasted URL, and those should read
    // and link like any other ticket rather than as a wall of URL.
    var key = ticket ? jiraTicketKey(ticket) : null;
    // From the build's own config: `ee-utils` cannot read `process.env`, which
    // webpack replaces wholesale.
    var href = key != null ? jiraTicketUrl(key, process.env.JIRA_TENANT_URL) : undefined;
    if (!ticket)
        return React.createElement("label", { className: className }, emptyText);
    if (href == null)
        return React.createElement("label", { className: className }, ticket);
    return (React.createElement("a", { href: href, target: "_blank", rel: "noreferrer", 
        // The incidents table navigates on row click, so a ticket link inside a
        // row has to keep its own click to itself.
        onClick: function (e) { return e.stopPropagation(); }, className: "underline hover:text-teal ".concat(className !== null && className !== void 0 ? className : "") }, key));
};
/**
 * A ticket as one of the detail page's stats.
 *
 * Mirrors `SingleStat`'s markup rather than extending it: `SingleStat` takes a
 * plain string and renders it through a text transition, so there is nowhere
 * for an anchor to go.
 */
export var TicketStat = function (_a) {
    var title = _a.title, ticket = _a.ticket;
    return (React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
        React.createElement("label", { className: "font-N8p5 text-black-400 whitespace-nowrap" }, title),
        React.createElement(TicketLink, { ticket: ticket, className: "font-N7 text-white w-fit" })));
};
